import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AuthService } from './auth.service';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter, take, map, Observable } from 'rxjs';
import { NotificationService } from '../services/notification.service';

export const initialRouteGuard: CanActivateFn = (): Observable<boolean | UrlTree> => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const notificationService = inject(NotificationService);

  return toObservable(authService.isAuthResolved).pipe(
    filter((resolved) => resolved),
    take(1),
    map(() => {
      const role = authService.userRole();

      switch (role) {
        case 'super_admin':
          return router.createUrlTree(['/organizations']);
        case 'org_admin':
        case 'dep_admin':
          // NOTE: 将来的に組織管理者と部門管理者でデータフィルタリングを分ける想定
          return router.createUrlTree(['/sites/map']);
        case 'site_manager': {
          const siteId = authService.userSiteId();
          if (siteId) {
            return router.createUrlTree(['/sites/detail', siteId]);
          }
          return router.createUrlTree(['/sites/detail']);
        }
        default:
          notificationService.error('権限が設定されていません。管理者に連絡してください。');
          authService.signOut();
          return router.createUrlTree(['/sign-in']);
      }
    })
  );
};
